import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col, Spinner } from 'react-bootstrap';
import { Icon } from '@iconify/react';
import { revokePreviewUrls } from '../utils/photoPreview';
import { ClickablePhoto, usePhotoLightbox } from './PhotoLightbox';

const PhotoUploadModal3 = ({ PhotoUpload, PhotoUploadToggle, ThankyouOpen, loadBtn, OtherDataResponse, OtherDataImg }) => {
  const [step, setStep] = useState(1);
  const totalSteps = 1;
  const [Multipleimages, setMultipleImages] = useState([]);
  const { openLightbox, closeLightbox } = usePhotoLightbox();

  useEffect(() => {
    if (!PhotoUpload) {
      const timer = window.setTimeout(() => closeLightbox(), 0);
      setMultipleImages((prev) => {
        revokePreviewUrls(prev.map((img) => img.id));
        return [];
      });
      setStep(1);
      return () => window.clearTimeout(timer);
    }
    return undefined;
  }, [PhotoUpload, closeLightbox]);

  const handleMultipleFileChange = (event) => {
    const files = Array.from(event.target.files);
    previewImages(files);
    event.target.value = '';
  };

  const handleDrop = (event) => {
    event.preventDefault();
    const files = Array.from(event.dataTransfer.files);
    previewImages(files);
  };

  const previewImages = (files) => {
    const newImages = files
      .filter((file) => file.type.startsWith('image/'))
      .map((file) => ({
        id: URL.createObjectURL(file),
        file,
      }));
    setMultipleImages((prev) => [...prev, ...newImages]);
  };

  const removeImage = (id) => {
    revokePreviewUrls([id]);
    setMultipleImages((prev) => prev.filter((img) => img.id !== id));
  };

  const submitBtn = () => {
    ThankyouOpen(OtherDataResponse, OtherDataImg, Multipleimages);
  };

  const handleNext = () => {
    if (step < totalSteps) {
      setStep((prevStep) => prevStep + 1);
    }
  };

  const handleBack = () => {
    if (step > 1) setStep((prevStep) => prevStep - 1);
  };

  return (
    <>
      <Modal show={PhotoUpload} onHide={PhotoUploadToggle} centered size="lg" className="modal-getstarted rs-re-modal-soft-open rs-re-photo-summary">
        <button type="button" className="rs-lc-close" onClick={PhotoUploadToggle} aria-label="Close">
          <Icon icon="tabler:x" width={22} height={22} />
        </button>
        <Modal.Body className="rs-lc-body pt-2">
          <div className="d-flex align-items-end justify-content-between gap-3 flex-wrap mb-50">
            <div className="section-heading">
              {step < 1 ? (
                <>
                  <h4 className="subheading">{step}/5</h4>
                  <h2>Photo Upload</h2>
                </>
              ) : (
                <h2>Photos Summary</h2>
              )}
            </div>
            <div className="d-flex align-items-center justify-content-center gap-2 flex-wrap">
              {step > 1 && (
                <Button variant="outline-primary" onClick={handleBack} style={{ minWidth: 180 }}>
                  Back
                </Button>
              )}
              {step < totalSteps ? (
                <Button onClick={handleNext} style={{ minWidth: 180 }}>
                  Next <Icon icon="mynaui:arrow-right" width="24" height="24" />
                </Button>
              ) : (
                <Button style={{ minWidth: 180 }} onClick={submitBtn} disabled={loadBtn}>
                  {loadBtn ? (
                    <Spinner color="#00316D" size={1} speed={1} animating={true} style={{ marginTop: '10px' }} />
                  ) : (
                    <>
                      Submit <Icon icon="mynaui:arrow-right" width="24" height="24" />
                    </>
                  )}
                </Button>
              )}
            </div>
          </div>
          <Row className="g-0 rs-re-step-panel">
            <Col xs={12}>
              <div className="rs-re-summary rs-re-summary--extras-only">
                <p className="rs-re-summary__lede">
                  Upload photos of your project. You can add several files at once.
                </p>
                <section className="rs-re-summary-extras" aria-labelledby="re-summary-extras-other-heading">
                  <h3 id="re-summary-extras-other-heading" className="rs-re-summary-extras__title">
                    Your photos
                  </h3>
                  <p className="rs-re-summary-extras__hint">
                    Drag and drop here, or click to browse. Remove any thumbnail with the × control.
                  </p>
                  <div className="rs-re-summary-extras__grid">
                    <div
                      className="rs-re-summary-dropzone additional-div"
                      onDragOver={(e) => e.preventDefault()}
                      onDrop={handleDrop}
                    >
                      <Form.Label htmlFor="uploadphotosnew-other" className="rs-re-summary-dropzone__label">
                        <Icon icon="garden:upload-fill-16" width={28} height={28} />
                        <span className="rs-re-summary-dropzone__title">Add photos</span>
                        <span className="rs-re-summary-dropzone__sub">Drop files or browse</span>
                      </Form.Label>
                      <Form.Control
                        type="file"
                        id="uploadphotosnew-other"
                        className="d-none"
                        multiple
                        onChange={handleMultipleFileChange}
                        accept="image/*"
                      />
                    </div>
                    {Multipleimages.map((img) => (
                      <div
                        key={img.id}
                        className="rs-re-summary-thumb preview-container uploadRemove_box"
                      >
                        <ClickablePhoto
                          src={img.id}
                          alt="Uploaded project photo"
                          onView={openLightbox}
                          fill
                        />
                        <button
                          type="button"
                          className="remove-btn close-preview"
                          onClick={() => removeImage(img.id)}
                          aria-label="Remove photo"
                        >
                          <Icon icon="tabler:x" width={18} height={18} />
                        </button>
                      </div>
                    ))}
                  </div>
                </section>
              </div>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PhotoUploadModal3;
